
export const MinimumWageMixin = {
  data () {
    return {
      contractId: 0,
      versionId: 0,
      editionId: 0
    }
  },
  computed:{
    canUserEdit() {
      return (
        (this.$IsUserInRole("VertragsmanagementVerwaltung") ||
         this.$IsUserInRole('VertragsmanagementUniaVertragsverantworlich') && this.$store.state.mindestLohnKonfiguration.Tenants.find(x => x.id == 4 )) &&
        this.$store.state.contractConfiguration.canUserEdit
      );
    },
  },
  created () {
    this.contractId = this.$route.params.vertragsId;
    this.versionId = Number.parseInt(this.$route.params.versionsId);
    this.editionId = Number.parseInt(this.$route.params.editionsId);
  },
  methods: {
    startLoading(identifier) {
      this.$store.commit('setLoading', identifier);
      this.$store.commit('setErrorObject', { name: identifier, errorObject: null });
    },
    stopLoading(identifier, error) {
      this.$store.commit('unsetLoading', identifier);
      this.$store.commit('setErrorObject', { name: identifier, errorObject: error });
    },
    showModal(modalId) {
      this.$refs[modalId].show();
    },
    hideModal(modalId) {
      this.$refs[modalId].hide();
    }
  }
}